export function usePageQueryActive() {
  const route = useRoute()
  const router = useRouter()
  const path = route.path
  const view = route.query.view
  let disposed = false
  onScopeDispose(() => { disposed = true })

  // Nuxt keeps the outgoing page's route until the new page has rendered.
  // Use the router's committed location before letting that page write query state.
  return () => !disposed
    && router.currentRoute.value.path === path
    && router.currentRoute.value.query.view === view
}
